import {
  ButtonBase,
  IconButton,
  ListItem,
  Menu,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'

import { ImportDataMpdal } from '../../components/ImportDataMpdal'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Accommodation } from '../../types/accommodation'
import useStyles from './styles/AccommodationsTable.styles'

interface AccommodationRowProps {
  hasAccessToViewRoomType: boolean | undefined
  hasAccessToViewRatePlan: boolean | undefined
  data: Accommodation
  RoleAccessToViewAccommodationDeatils: boolean | undefined
  RoleAccessToViewImportData: boolean | undefined
}

const AccommodationRow: React.FC<AccommodationRowProps> = ({
  hasAccessToViewRoomType,
  hasAccessToViewRatePlan,
  data,
  RoleAccessToViewAccommodationDeatils,
  RoleAccessToViewImportData
}) => {
  const {
    basicDetails: {
      name,
      propertyCode,
      accommodationID,
      totaRoomNumber,
      displayPropertyCode
    }
  } = data
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleClickMoreOptions = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div
      className={[
        classes.tableRowRoot,
        !RoleAccessToViewAccommodationDeatils ? classes.cursorDefault : ''
      ].join(' ')}>
      <ButtonBase
        data-cy="findNewAccommodation"
        className={classes.tableRow}
        component={LocalizedLink}
        disabled={!RoleAccessToViewAccommodationDeatils}
        to={
          RoleAccessToViewAccommodationDeatils
            ? `/accommodations/${accommodationID}/${propertyCode}/details`
            : '/accommodations'
        }>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{displayPropertyCode}</Typography>
        </div>
        <div>
          <Typography variant="body1">{totaRoomNumber}</Typography>
        </div>
      </ButtonBase>
      <div className={classes.rowMenu}>
        <IconButton onClick={handleClickMoreOptions}>
          <MoreIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <ListItem
            disabled={!hasAccessToViewRoomType}
            button
            component={LocalizedLink}
            to={`/accommodations/${accommodationID}/${propertyCode}/room-types/list`}>
            {getTranslate('View Room Types')}
          </ListItem>
          <ListItem
            disabled={!hasAccessToViewRatePlan}
            button
            component={LocalizedLink}
            to={`/accommodations/${accommodationID}/${propertyCode}/rate-plans/list`}>
            {getTranslate('View Rate Plans')}
          </ListItem>
          {RoleAccessToViewImportData && (
            <ListItem
              disabled={!RoleAccessToViewImportData}
              button
              onClick={() => setIsOpen(true)}>
              {getTranslate('Import Data')}
            </ListItem>
          )}
        </Menu>
      </div>
      {isOpen && (
        <ImportDataMpdal
          propertyCode={propertyCode}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  )
}

export default AccommodationRow
